import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useClipboard from 'react-use-clipboard';

import Input from '../../../../../../../components/global/Input';
import Button from '../../../../../../../components/global/Button';
import CheckboxIcon from '../../../../../../../components/icons/CheckboxIcon';

const propTypes = {
  className: PropTypes.string,
  url: PropTypes.string.isRequired,
};

const ReferralUrlInput = ({ url, className }) => {
  const classes = classNames({
    'shutterbug-landing-referral-input': true,
    [className]: !!className,
  });

  const [isCopied, setCopied] = useClipboard(url, {
    successDuration: 5000,
  });

  return (
    <div className={classes}>
      <Input id="referral" value={url} readOnly />
      <Button btnStyle="link" onClick={setCopied}>
        {isCopied ? (
          <Fragment>
            <CheckboxIcon color="#fff" size={18} /> Copied
          </Fragment>
        ) : (
          <Fragment>Copy Link</Fragment>
        )}
      </Button>
    </div>
  );
};

ReferralUrlInput.propTypes = propTypes;

export default ReferralUrlInput;
